import * as React from "react";
import { Button as ShadcnButton } from "@/components/ui/button";
import { cn } from "@/lib/utils";

/**
 * Legacy unified Button wrapper — delegates to shadcn Button.
 * Maps the historical variant/size enum to shadcn's API so existing
 * call sites continue to work without changes.
 */
const variantMap = {
  primary: "default",
  secondary: "secondary",
  green: "success",
  gradient: "default",
  icon: "ghost",
  link: "link",
};

const sizeMap = { small: "sm", medium: "default", large: "lg" };

const Button = React.forwardRef(
  (
    {
      variant = "primary",
      size = "medium",
      fullWidth = false,
      className,
      ...props
    },
    ref,
  ) => (
    <ShadcnButton
      ref={ref}
      variant={variantMap[variant] || "default"}
      size={variant === "icon" ? "icon" : sizeMap[size] || "default"}
      className={cn(fullWidth && "w-full", className)}
      {...props}
    />
  ),
);
Button.displayName = "Button";

export default Button;
